import { configureStore } from '@reduxjs/toolkit';
import appSlice from './appSlice';
import analyzeSlice from './features/analyze/analyzeSlice';
import searchMiddleware from './features/filters/searchMiddleware';
import searchSlice from './features/filters/searchSlice';
import formSlice from './features/form/formSlice';

const store = configureStore({
  reducer: {
    app: appSlice.reducer,
    search: searchSlice.reducer,
    form: formSlice.reducer,
    analyze: analyzeSlice.reducer,
  },
  middleware: [],
});

export default store;